import { Navigate } from 'react-router';
import { useAuth } from '~/contexts/AuthContext';
import ValueProposition from '~/components/landing/ValueProposition';
import LoginPanel from '~/components/landing/LoginPanel';
import BrandsCarousel from '~/components/landing/BrandsCarousel';
import CaseStudies from '~/components/landing/CaseStudies';
import TrustSection from '~/components/landing/TrustSection';
import TeamSection from '~/components/landing/TeamSection';
import ContactSection from '~/components/landing/ContactSection';
import BlogCarousel from '~/components/landing/BlogCarousel';

export default function Landing() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return (
    <div className="h-screen overflow-y-auto">
      {/* Hero Section - Split Layout */}
      <section className="min-h-screen flex flex-col lg:flex-row">
        {/* Left - Value Prop */}
        <div className="flex-1 p-8 lg:p-16 bg-base-100">
          <ValueProposition />
        </div>

        {/* Right - Login */}
        <div className="flex-1 p-8 lg:p-16 bg-base-200">
          <LoginPanel />
        </div>
      </section>

      {/* Brands Carousel */}
      <BrandsCarousel />

      {/* Case Studies Section */}
      <CaseStudies />

      {/* Blog Section */}
      <BlogCarousel />

      {/* Team Section */}
      <TeamSection />

      {/* Trust/Security Section */}
      <TrustSection />

      {/* Contact Section */}
      <ContactSection />

      {/* Footer */}
      <footer className="py-8 px-8 lg:px-16 bg-base-300 text-center">
        <p className="text-sm opacity-60">
          &copy; {new Date().getFullYear()} Gamgee Analytics. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
